<template>
	<!-- Select time slot -->
	<div
		class="full-modal booking-modal modal-time-slots hidden-md hidden-lg"
		v-bind:class="{ 'modal-show': ui.modalState == 3 }"
	>
		<BookingCalendarWeekMobileHeader />
		<BookingCalendarMonthMobileHeader />

		<div class="padding-top-xs-5 margin-top-xs-5 modal-time-slots-body" v-if="isActivityBookable(activities.selected.activity_id)">
			<div
				class="modal-body padding-left-xs-0 padding-right-xs-0"
				:class="{
					'modal-body-no-padding-bottom':
						ui.calendarViewType == 'week',
				}"
			>
				<ProviderAndCalendarNavMobile />

				<div
					class="book-time-single-date-xs"
					:class="{
						'book-time-inactive':
							!activities.selected || ui.loading.times,
					}"
				>
					<BookingCalendarMonth
						v-if="ui.calendarViewType == 'month'"
					/>
				</div>
				<BookingCalendarWeekMobile />
			</div>
		</div>

		<div
			class="modal-body padding-left-xs-0 padding-right-xs-0"
			v-if="!isActivityBookable(activities.selected.activity_id)"
		>
			<div class="alert alert-nk message-wrapper" v-html="unbookableTreatmentMessage"></div>
		</div>

	</div>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ProviderAndCalendarNavMobile from "./ProviderAndCalendarNavMobile.vue";
import BookingCalendarMonth from "./BookingCalendarMonth.vue";
import BookingCalendarWeekMobile from "./BookingCalendarWeekMobile.vue";
import BookingCalendarWeekMobileHeader from "./BookingCalendarWeekMobileHeader.vue";
import BookingCalendarMonthMobileHeader from "./BookingCalendarMonthMobileHeader.vue";

export default {
	components: {
		ProviderAndCalendarNavMobile,
		BookingCalendarMonth,
		BookingCalendarWeekMobile,
		BookingCalendarWeekMobileHeader,
		BookingCalendarMonthMobileHeader,
	},
	computed: {
		...mapState([
			"activityGroups",
			"activities",
			"providers",
			"selectedSlot",
			"dates",
			"ui",
			"booking",
			"patient",
			'unbookableTreatments',
			'unbookableTreatmentMessage'
		]),
		...mapGetters([
			"dateIsInThePast",
			"activityIsCampaign",
			"formatProviderName",
			"selectedSlotFormated",
			"formIsValid",
			"noAvailableTimesForWeek",
			"isActivityBookable"
		]),
	},
	methods: {
		...mapActions([
			"setActivityGroup",
			"setActivity",
			"setupActiveDates",
			"setSelectedSlot",
			"setProvider",
			"getRealWeekday",
			"setModalState",
			"handleSwipe",
			"shouldDeselectTimeslot",
		]),
	},
};
</script>